/** Frontmatter for the "week8-waiver-wire-darkness-report" article; the Body lives in week8-waiver-wire-darkness-report.jsx. */
const meta = {
  slug: 'week8-waiver-wire-darkness-report',
  title: 'Week 8 Waiver Wire: The Darkness Report',
  category: 'Waivers',
  author: 'Andy Darkness',
  excerpt:
    'Jonah Coleman, KC Concepcion and Omar Cooper Jr. lead a Week 8 wire shaped by Terry McLaurin\'s torn patellar tendon, four byes and a Week 7 report card where the cheap superflex quarterbacks paid. A FAAB ladder, the full board, a superflex corner, a D/ST streaming chart built on implied totals, an IDP board, the injury ledger, the Week 7 receipts and the bid sheet.',
  readMinutes: 15,
  date: '2026-10-27',
};

export default meta;
